var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _path24, _path25, _path26, _path27, _path28, _path29, _g4, _path30, _path31, _path32, _path33, _path34, _path35, _g5, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g6, _path50, _path51, _path52, _g7, _path53, _path54, _path55, _path56, _path57, _path58, _g8, _path59, _path60, _path61, _path62, _path63, _path64, _g9, _path65, _path66, _path67, _path68, _path69, _path70, _g10, _path71, _g11, _path72, _g12, _path73, _g13, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExplanation1 = function SvgExplanation1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 361,
    viewBox: "0 0 478 361",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.864 226.603C452.578 216.103 453.394 198.197 444.188 190.824C436.101 184.351 429.813 193.136 427.543 200.223C422.045 217.415 424.626 236.372 424.643 254.118C424.643 254.387 424.643 254.656 424.643 254.959C424.214 268.023 422.642 282.154 424.071 295.193C424.071 295.193 422.667 282.129 412.411 287.728C402.155 293.327 417.539 322.708 417.539 322.708C417.539 322.708 405.417 313.847 399.818 321.312C394.219 328.777 406.812 337.167 406.812 337.167C406.812 337.167 395.152 333.905 395.152 337.167C395.152 340.429 398.885 343.228 409.612 344.632H467.433C467.433 344.632 476.764 339.496 474.898 333.905C473.031 328.315 463.229 331.535 463.229 331.535C463.229 331.535 478.16 313.343 477.226 305.415C476.293 297.488 457.168 306.819 457.168 306.819C457.168 306.819 472.09 269.04 469.291 252.252C467.088 239.028 456.823 248.048 451.233 253.16C452.549 244.372 453.095 235.486 452.864 226.603Z",
    fill: "#94E0B3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M452.864 226.603C452.578 216.103 453.394 198.197 444.188 190.824C436.101 184.351 429.813 193.136 427.543 200.223C422.045 217.415 424.626 236.372 424.643 254.118C424.643 254.387 424.643 254.656 424.643 254.959C424.214 268.023 422.642 282.154 424.071 295.193C424.071 295.193 422.667 282.129 412.411 287.728C402.155 293.327 417.539 322.708 417.539 322.708C417.539 322.708 405.417 313.847 399.818 321.312C394.219 328.777 406.812 337.167 406.812 337.167C406.812 337.167 395.152 333.905 395.152 337.167C395.152 340.429 398.885 343.228 409.612 344.632H467.433C467.433 344.632 476.764 339.496 474.898 333.905C473.031 328.315 463.229 331.535 463.229 331.535C463.229 331.535 478.16 313.343 477.226 305.415C476.293 297.488 457.168 306.819 457.168 306.819C457.168 306.819 472.09 269.04 469.291 252.252C467.088 239.028 456.823 248.048 451.233 253.16C452.549 244.372 453.095 235.486 452.864 226.603Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M434.312 344.129L438.516 215.869",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M436.648 290.494L458.565 269.974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M446.906 281.163L451.572 268.108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.457 306.349L435.245 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M463.232 316.613L435.246 331.072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.309 325.003L458.565 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434.312 344.129L438.516 215.869",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M436.648 290.494L458.565 269.974",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M446.906 281.163L451.572 268.108",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M418.457 306.349L435.245 324.541",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M463.232 316.613L435.246 331.072",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M448.309 325.003L458.565 324.541",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M434.312 344.129L438.516 215.869",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M436.648 290.494L458.565 269.974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M446.906 281.163L451.572 268.108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.457 306.35L435.245 324.542",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M463.232 316.615L435.246 331.074",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M448.309 325.003L458.565 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M354.195 318.211C354.195 331.249 364.527 341.825 364.527 341.825C364.527 341.825 374.859 331.249 374.859 318.211C374.859 305.172 364.527 294.596 364.527 294.596C364.527 294.596 354.195 305.163 354.195 318.211Z",
    fill: "#94E0B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M347.033 338.328C352.077 343.985 360.601 344.599 360.601 344.599C360.601 344.599 361.013 336.033 356.003 330.375C350.992 324.717 342.434 324.104 342.434 324.104C342.434 324.104 342.014 332.67 347.033 338.328Z",
    fill: "#94E0B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.362 330.182C368.091 335.604 368.125 344.179 368.125 344.179C368.125 344.179 376.691 343.952 381.954 338.521C387.216 333.09 387.2 324.524 387.2 324.524C387.2 324.524 378.625 324.751 373.362 330.182Z",
    fill: "#94E0B3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.195 318.211C354.195 331.25 364.527 341.825 364.527 341.825C364.527 341.825 374.859 331.25 374.859 318.211C374.859 305.172 364.527 294.597 364.527 294.597C364.527 294.597 354.195 305.164 354.195 318.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.527 341.825V294.597",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.526 311.385L358.742 306.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.621 319.186L371.784 308.812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.526 323.683L355.984 316.067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.621 329.745L373.07 322.221",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.62 334.982L358.004 329.745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.033 338.328C352.077 343.986 360.601 344.599 360.601 344.599C360.601 344.599 361.013 336.033 356.003 330.375C350.992 324.718 342.434 324.104 342.434 324.104C342.434 324.104 342.014 332.67 347.033 338.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.6 344.599L342.434 324.104",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.889 331.392L344.434 331.426",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.933 334.737L351.051 327.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.625 336.731L346.992 336.706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M355.996 339.319L356.761 332.804",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.013 341.589L353.129 341.867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.362 330.182C368.091 335.604 368.125 344.179 368.125 344.179C368.125 344.179 376.691 343.952 381.954 338.522C387.216 333.091 387.2 324.524 387.2 324.524C387.2 324.524 378.625 324.751 373.362 330.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M368.125 344.179L387.2 324.524",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.416 331.511L380.055 327.072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M377.305 334.797L384.476 333.368",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.447 336.63L374.977 330.014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.035 339.186L379.592 339.471",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M370.924 341.363L370.285 336.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M364.527 341.825V294.596",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M364.53 311.384L358.746 306.332",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M364.621 319.186L371.784 308.812",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.529 323.683L355.988 316.067",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M364.621 329.745L373.07 322.221",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M364.62 334.982L358.004 329.745",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.531 341.825V294.597",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.53 311.385L358.746 306.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.621 319.186L371.784 308.812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.529 323.683L355.988 316.067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.621 329.745L373.07 322.221",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.624 334.982L358.008 329.745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M360.604 344.599L342.438 324.104",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M348.893 331.393L344.438 331.426",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M351.933 334.738L351.051 327.483",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M353.625 336.73L346.992 336.705",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M355.996 339.319L356.761 332.804",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M358.013 341.59L353.129 341.867",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M360.604 344.599L342.438 324.104",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M348.893 331.392L344.438 331.425",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M351.937 334.738L351.055 327.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M353.625 336.729L346.992 336.704",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M355.996 339.319L356.761 332.804",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M358.013 341.59L353.129 341.867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M368.125 344.179L387.2 324.524",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M380.416 331.51L380.055 327.071",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M377.305 334.797L384.476 333.368",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M375.447 336.629L374.977 330.013",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M373.035 339.185L379.592 339.471",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M370.924 341.362L370.285 336.52",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M368.125 344.179L387.2 324.524",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M380.416 331.51L380.055 327.071",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M377.305 334.797L384.476 333.368",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M375.447 336.63L374.977 330.014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M373.035 339.186L379.592 339.471",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M370.924 341.363L370.285 336.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4045 226.603C25.6819 216.103 24.8748 198.197 34.0801 190.824C42.1673 184.351 48.4555 193.136 50.7168 200.223C56.2232 217.414 53.6339 236.371 53.6255 254.118C53.6255 254.387 53.6255 254.656 53.6255 254.958C54.0627 268.022 55.6263 282.154 54.2056 295.193C54.2056 295.193 55.6011 282.129 65.8656 287.728C76.1301 293.326 60.7292 322.708 60.7292 322.708C60.7292 322.708 72.8599 313.847 78.4588 321.312C84.0576 328.777 71.4812 337.133 71.4812 337.133C71.4812 337.133 83.1413 333.872 83.1413 337.133C83.1413 340.395 79.4087 343.195 68.6818 344.598H10.8357C10.8357 344.598 1.50438 339.462 3.37065 333.872C5.23693 328.281 15.0307 331.535 15.0307 331.535C15.0307 331.535 0.108873 313.343 1.04201 305.415C1.97515 297.488 21.1003 306.819 21.1003 306.819C21.1003 306.819 6.17006 269.04 8.96947 252.277C11.172 239.053 21.4449 248.073 27.0269 253.185C25.7123 244.388 25.1694 235.494 25.4045 226.603Z",
    fill: "#94E0B3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.4045 226.603C25.6819 216.103 24.8748 198.197 34.0801 190.824C42.1673 184.351 48.4555 193.136 50.7168 200.223C56.2232 217.414 53.6339 236.371 53.6255 254.118C53.6255 254.387 53.6255 254.656 53.6255 254.958C54.0627 268.022 55.6263 282.154 54.2056 295.193C54.2056 295.193 55.6011 282.129 65.8656 287.728C76.1301 293.326 60.7292 322.708 60.7292 322.708C60.7292 322.708 72.8599 313.847 78.4588 321.312C84.0576 328.777 71.4812 337.133 71.4812 337.133C71.4812 337.133 83.1413 333.872 83.1413 337.133C83.1413 340.395 79.4087 343.195 68.6818 344.598H10.8357C10.8357 344.598 1.50438 339.462 3.37065 333.872C5.23693 328.281 15.0307 331.535 15.0307 331.535C15.0307 331.535 0.108873 313.343 1.04201 305.415C1.97515 297.488 21.1003 306.819 21.1003 306.819C21.1003 306.819 6.17006 269.04 8.96947 252.277C11.172 239.053 21.4449 248.073 27.0269 253.185C25.7123 244.388 25.1694 235.494 25.4045 226.603Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9488 344.129L39.7539 215.869",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6198 290.494L19.6953 269.974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3571 281.163L26.6914 268.108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8037 306.349L43.0156 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 316.613L43.017 331.072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9598 325.003L19.6953 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9488 344.129L39.7539 215.869",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6198 290.494L19.6953 269.974",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3571 281.163L26.6914 268.108",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8037 306.349L43.0156 324.541",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 316.613L43.017 331.072",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9598 325.003L19.6953 324.541",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.9488 344.129L39.7539 215.869",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M41.6198 290.494L19.6953 269.974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.3571 281.163L26.6914 268.108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M59.8037 306.35L43.0156 324.542",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M15.0312 316.615L43.017 331.074",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.9598 325.003L19.6953 324.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M125.756 318.211C125.756 331.249 115.424 341.825 115.424 341.825C115.424 341.825 105.109 331.249 105.109 318.211C105.109 305.172 115.441 294.596 115.441 294.596C115.441 294.596 125.756 305.163 125.756 318.211Z",
    fill: "#94E0B3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M132.909 338.328C127.865 343.985 119.34 344.599 119.34 344.599C119.34 344.599 118.928 336.033 123.947 330.375C128.966 324.717 137.515 324.104 137.515 324.104C137.515 324.104 137.894 332.67 132.909 338.328Z",
    fill: "#94E0B3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.587 330.182C111.85 335.604 111.825 344.179 111.825 344.179C111.825 344.179 103.258 343.952 97.9873 338.521C92.7164 333.09 92.75 324.524 92.75 324.524C92.75 324.524 101.316 324.751 106.587 330.182Z",
    fill: "#94E0B3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.756 318.211C125.756 331.25 115.424 341.825 115.424 341.825C115.424 341.825 105.109 331.25 105.109 318.211C105.109 305.172 115.441 294.597 115.441 294.597C115.441 294.597 125.756 305.164 125.756 318.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.422 341.825V294.597",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.422 311.385L121.206 306.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.33 319.186L108.168 308.812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.422 323.683L123.963 316.067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.331 329.745L106.883 322.221",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.332 334.982L121.94 329.745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.909 338.328C127.865 343.986 119.34 344.599 119.34 344.599C119.34 344.599 118.928 336.033 123.947 330.375C128.966 324.718 137.515 324.104 137.515 324.104C137.515 324.104 137.894 332.67 132.909 338.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.34 344.599L137.515 324.104",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.059 331.392L135.506 331.426",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.016 334.737L128.898 327.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.316 336.731L132.958 336.706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.949 339.319L123.184 332.804",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.938 341.589L126.822 341.867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.587 330.182C111.85 335.604 111.825 344.179 111.825 344.179C111.825 344.179 103.258 343.952 97.9873 338.522C92.7164 333.091 92.75 324.524 92.75 324.524C92.75 324.524 101.316 324.751 106.587 330.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.825 344.179L92.75 324.524",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.5273 331.511L99.8972 327.072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.644 334.797L95.4727 333.368",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.492 336.63L104.971 330.014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.909 339.186L100.352 339.471",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.023 341.363L109.654 336.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M115.422 341.825V294.596",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M115.422 311.384L121.206 306.332",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.33 319.186L108.168 308.812",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M115.422 323.683L123.963 316.067",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M115.331 329.745L106.883 322.221",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M115.332 334.982L121.94 329.745",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.426 341.825V294.597",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.426 311.385L121.21 306.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.33 319.186L108.168 308.812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.426 323.683L123.967 316.067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.331 329.745L106.883 322.221",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.332 334.982L121.94 329.745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 344.599L137.515 324.104",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.059 331.393L135.506 331.426",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.016 334.738L128.898 327.483",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M126.316 336.73L132.958 336.705",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M123.949 339.319L123.184 332.804",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M121.938 341.59L126.822 341.867",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M119.34 344.599L137.515 324.104",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.059 331.392L135.506 331.425",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.016 334.738L128.898 327.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M126.316 336.729L132.958 336.704",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M123.949 339.319L123.184 332.804",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.938 341.59L126.822 341.867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.825 344.179L92.75 324.524",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5273 331.51L99.8972 327.071",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M102.644 334.797L95.4727 333.368",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M104.492 336.629L104.971 330.013",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M106.909 339.185L100.352 339.471",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M109.023 341.362L109.654 336.52",
    stroke: "#94E0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M111.825 344.179L92.75 324.524",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M99.5273 331.51L99.8972 327.071",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M102.644 334.797L95.4727 333.368",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.492 336.63L104.971 330.014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M106.909 339.186L100.352 339.471",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M109.023 341.363L109.654 336.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M358.465 94.7534H131.209C131.141 94.7546 131.073 94.7421 131.01 94.7168C130.947 94.6916 130.889 94.654 130.841 94.6063C130.792 94.5585 130.754 94.5016 130.727 94.4388C130.701 94.3761 130.687 94.3087 130.688 94.2406C130.688 94.1024 130.742 93.9698 130.84 93.8721C130.938 93.7743 131.07 93.7194 131.209 93.7194H358.465C358.533 93.7194 358.601 93.733 358.664 93.7593C358.726 93.7855 358.783 93.8241 358.831 93.8726C358.879 93.9211 358.916 93.9786 358.942 94.0418C358.967 94.105 358.979 94.1726 358.978 94.2406C358.978 94.3766 358.924 94.5071 358.828 94.6032C358.732 94.6994 358.601 94.7534 358.465 94.7534Z",
    fill: "#94E0B3"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.465 94.7534H131.209C131.141 94.7546 131.073 94.7421 131.01 94.7168C130.947 94.6916 130.889 94.654 130.841 94.6063C130.792 94.5585 130.754 94.5016 130.727 94.4388C130.701 94.3761 130.687 94.3087 130.688 94.2406C130.688 94.1024 130.742 93.9698 130.84 93.8721C130.938 93.7743 131.07 93.7194 131.209 93.7194H358.465C358.533 93.7194 358.601 93.733 358.664 93.7593C358.726 93.7855 358.783 93.8241 358.831 93.8726C358.879 93.9211 358.916 93.9786 358.942 94.0418C358.967 94.105 358.979 94.1726 358.978 94.2406C358.978 94.3766 358.924 94.5071 358.828 94.6032C358.732 94.6994 358.601 94.7534 358.465 94.7534Z",
    fill: "white"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M358.012 184.889H130.756C130.688 184.89 130.62 184.878 130.557 184.853C130.494 184.828 130.436 184.79 130.388 184.742C130.339 184.694 130.3 184.638 130.274 184.575C130.248 184.512 130.234 184.445 130.234 184.377C130.234 184.238 130.289 184.106 130.387 184.008C130.485 183.91 130.617 183.855 130.756 183.855H358.012C358.08 183.855 358.148 183.869 358.211 183.895C358.273 183.921 358.33 183.96 358.378 184.009C358.426 184.057 358.463 184.115 358.489 184.178C358.514 184.241 358.526 184.309 358.525 184.377C358.525 184.444 358.512 184.511 358.486 184.573C358.46 184.635 358.423 184.692 358.375 184.739C358.327 184.787 358.271 184.825 358.209 184.85C358.146 184.876 358.08 184.889 358.012 184.889Z",
    fill: "#94E0B3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.012 184.889H130.756C130.688 184.89 130.62 184.878 130.557 184.853C130.494 184.828 130.436 184.79 130.388 184.742C130.339 184.694 130.3 184.638 130.274 184.575C130.248 184.512 130.234 184.445 130.234 184.377C130.234 184.238 130.289 184.106 130.387 184.008C130.485 183.91 130.617 183.855 130.756 183.855H358.012C358.08 183.855 358.148 183.869 358.211 183.895C358.273 183.921 358.33 183.96 358.378 184.009C358.426 184.057 358.463 184.115 358.489 184.178C358.514 184.241 358.526 184.309 358.525 184.377C358.525 184.444 358.512 184.511 358.486 184.573C358.46 184.635 358.423 184.692 358.375 184.739C358.327 184.787 358.271 184.825 358.209 184.85C358.146 184.876 358.08 184.889 358.012 184.889Z",
    fill: "white"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M358.012 258.574H130.756C130.617 258.574 130.485 258.519 130.387 258.421C130.289 258.323 130.234 258.191 130.234 258.052C130.234 257.984 130.248 257.917 130.274 257.854C130.3 257.791 130.339 257.734 130.388 257.687C130.436 257.639 130.494 257.601 130.557 257.576C130.62 257.551 130.688 257.538 130.756 257.54H358.012C358.08 257.54 358.146 257.553 358.209 257.579C358.271 257.604 358.327 257.642 358.375 257.69C358.423 257.737 358.46 257.794 358.486 257.856C358.512 257.918 358.525 257.985 358.525 258.052C358.526 258.12 358.514 258.188 358.489 258.251C358.463 258.314 358.426 258.372 358.378 258.42C358.33 258.469 358.273 258.507 358.211 258.534C358.148 258.56 358.08 258.574 358.012 258.574Z",
    fill: "#94E0B3"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.012 258.574H130.756C130.617 258.574 130.485 258.519 130.387 258.421C130.289 258.323 130.234 258.191 130.234 258.052C130.234 257.984 130.248 257.917 130.274 257.854C130.3 257.791 130.339 257.734 130.388 257.687C130.436 257.639 130.494 257.601 130.557 257.576C130.62 257.551 130.688 257.538 130.756 257.54H358.012C358.08 257.54 358.146 257.553 358.209 257.579C358.271 257.604 358.327 257.642 358.375 257.69C358.423 257.737 358.46 257.794 358.486 257.856C358.512 257.918 358.525 257.985 358.525 258.052C358.526 258.12 358.514 258.188 358.489 258.251C358.463 258.314 358.426 258.372 358.378 258.42C358.33 258.469 358.273 258.507 358.211 258.534C358.148 258.56 358.08 258.574 358.012 258.574Z",
    fill: "white"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M179.07 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M190.023 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.977 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M211.934 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M222.887 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M244.793 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M255.746 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M266.703 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M277.656 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M288.609 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M299.562 271.04V347.726",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 278.161H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 288.568H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 298.976H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 309.384H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 319.79H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 330.198H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M179.617 340.606H299.017",
    stroke: "#253838",
    strokeWidth: 0.265171,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M204.703 297.941L188.68 347.339H222.239L206.208 297.941C206.156 297.782 206.056 297.643 205.921 297.544C205.786 297.446 205.622 297.393 205.455 297.393C205.288 297.393 205.125 297.446 204.99 297.544C204.854 297.643 204.754 297.782 204.703 297.941Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M235.253 281.582L213.926 347.339H258.111L236.758 281.582C236.707 281.423 236.607 281.284 236.471 281.185C236.336 281.087 236.173 281.034 236.006 281.034C235.838 281.034 235.675 281.087 235.54 281.185C235.405 281.284 235.305 281.423 235.253 281.582Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M263.362 309.241L250.996 347.34H277.225L264.833 309.241C264.775 309.093 264.674 308.966 264.543 308.877C264.412 308.787 264.257 308.739 264.098 308.739C263.939 308.739 263.784 308.787 263.653 308.877C263.521 308.966 263.42 309.093 263.362 309.241Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M280.304 322.32L272.191 347.338H289.921L281.809 322.32C281.757 322.161 281.657 322.022 281.522 321.923C281.387 321.825 281.224 321.772 281.056 321.772C280.889 321.772 280.726 321.825 280.591 321.923C280.455 322.022 280.355 322.161 280.304 322.32Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M177.624 246.804C172.817 246.804 168.118 245.379 164.122 242.708C160.125 240.038 157.01 236.242 155.17 231.801C153.331 227.36 152.85 222.474 153.787 217.759C154.725 213.045 157.04 208.714 160.439 205.316C163.838 201.917 168.168 199.602 172.883 198.664C177.597 197.726 182.484 198.208 186.924 200.047C191.365 201.887 195.161 205.002 197.832 208.998C200.502 212.995 201.928 217.694 201.928 222.501C201.921 228.944 199.358 235.122 194.802 239.679C190.245 244.235 184.068 246.798 177.624 246.804ZM177.624 205.334C174.229 205.336 170.911 206.344 168.089 208.232C165.267 210.119 163.068 212.8 161.77 215.937C160.472 219.074 160.134 222.526 160.797 225.855C161.46 229.184 163.096 232.242 165.497 234.642C167.898 237.042 170.957 238.676 174.286 239.338C177.616 240 181.067 239.659 184.204 238.36C187.34 237.06 190.02 234.86 191.906 232.037C193.792 229.214 194.799 225.896 194.799 222.501C194.794 217.948 192.983 213.583 189.763 210.364C186.543 207.146 182.177 205.337 177.624 205.334Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M177.623 246.804C174.343 246.814 171.095 246.155 168.078 244.867C165.062 243.579 162.34 241.69 160.078 239.314L165.231 234.379C166.828 236.057 168.751 237.392 170.881 238.302C173.012 239.211 175.306 239.675 177.623 239.667C179.877 239.667 182.109 239.223 184.192 238.36C186.275 237.497 188.167 236.233 189.761 234.639C191.355 233.045 192.62 231.152 193.482 229.07C194.345 226.987 194.789 224.755 194.789 222.5C194.789 220.246 194.345 218.014 193.482 215.931C192.62 213.848 191.355 211.956 189.761 210.362C188.167 208.768 186.275 207.503 184.192 206.641C182.109 205.778 179.877 205.334 177.623 205.334V198.197C180.814 198.197 183.975 198.825 186.923 200.047C189.872 201.268 192.551 203.058 194.808 205.315C197.065 207.572 198.855 210.251 200.076 213.2C201.298 216.148 201.926 219.309 201.926 222.5C201.926 225.692 201.298 228.852 200.076 231.801C198.855 234.75 197.065 237.429 194.808 239.686C192.551 241.942 189.872 243.733 186.923 244.954C183.975 246.175 180.814 246.804 177.623 246.804Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M237.562 246.804C232.755 246.806 228.055 245.382 224.057 242.712C220.06 240.043 216.943 236.248 215.102 231.807C213.262 227.366 212.779 222.479 213.716 217.764C214.653 213.049 216.967 208.718 220.365 205.318C223.764 201.918 228.094 199.603 232.809 198.664C237.524 197.726 242.411 198.207 246.852 200.046C251.294 201.885 255.09 205 257.761 208.997C260.432 212.994 261.857 217.693 261.857 222.5C261.851 228.943 259.289 235.119 254.734 239.675C250.18 244.231 244.004 246.795 237.562 246.804ZM237.562 205.334C234.168 205.337 230.85 206.347 228.029 208.235C225.209 210.124 223.011 212.806 221.714 215.943C220.418 219.08 220.08 222.531 220.744 225.86C221.409 229.189 223.045 232.246 225.446 234.645C227.848 237.044 230.907 238.677 234.236 239.338C237.566 239.999 241.016 239.658 244.152 238.358C247.288 237.059 249.968 234.858 251.853 232.036C253.739 229.213 254.745 225.895 254.745 222.5C254.739 217.947 252.925 213.582 249.704 210.363C246.482 207.145 242.116 205.336 237.562 205.334Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M247.02 244.887L244.246 238.322C247.892 236.776 250.891 234.019 252.737 230.516C254.583 227.013 255.162 222.979 254.376 219.098C253.59 215.218 251.487 211.728 248.423 209.219C245.359 206.711 241.522 205.338 237.562 205.334V198.197C243.17 198.197 248.605 200.137 252.946 203.687C257.287 207.237 260.267 212.179 261.38 217.675C262.493 223.172 261.671 228.884 259.054 233.843C256.437 238.803 252.185 242.704 247.02 244.887Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M297.495 246.804C292.688 246.804 287.989 245.379 283.993 242.708C279.996 240.038 276.881 236.242 275.041 231.801C273.202 227.36 272.721 222.473 273.658 217.759C274.596 213.045 276.911 208.714 280.31 205.315C283.709 201.916 288.039 199.602 292.754 198.664C297.468 197.726 302.355 198.207 306.796 200.047C311.237 201.886 315.032 205.001 317.703 208.998C320.373 212.995 321.799 217.694 321.799 222.5C321.792 228.944 319.229 235.122 314.673 239.678C310.117 244.235 303.939 246.797 297.495 246.804ZM297.495 205.334C294.1 205.334 290.781 206.341 287.958 208.227C285.135 210.113 282.935 212.794 281.635 215.931C280.336 219.068 279.996 222.519 280.659 225.849C281.321 229.179 282.956 232.238 285.357 234.639C287.757 237.04 290.816 238.675 294.146 239.337C297.476 239.999 300.928 239.659 304.064 238.36C307.201 237.061 309.882 234.861 311.768 232.038C313.655 229.215 314.661 225.896 314.661 222.5C314.657 217.949 312.847 213.585 309.629 210.367C306.41 207.149 302.046 205.338 297.495 205.334Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M314.325 219.079C313.527 215.205 311.421 211.724 308.359 209.221C305.297 206.718 301.467 205.345 297.512 205.334V198.197C303.113 198.211 308.539 200.154 312.876 203.698C317.213 207.242 320.198 212.172 321.328 217.658L314.325 219.079Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 171.288H301.453",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M210.141 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M232.973 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M255.797 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M278.621 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M301.453 171.288V168.858",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M206.947 138.847H190.512V158.308H206.947V138.847Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 116.14H213.336V161.553H229.771V116.14Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M252.603 84.3547H236.168V134.963H252.603V84.3547Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M275.427 131.719H258.992V141.453H275.427V131.719Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M298.251 125.875H281.816V151.179H298.251V125.875Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M206.947 158.316H190.512V171.296H206.947V158.316Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 161.562H213.336V171.297H229.771V161.562Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M252.603 134.954H236.168V171.287H252.603V134.954Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M275.427 141.445H258.992V171.288H275.427V141.445Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M298.251 151.18H281.816V171.288H298.251V151.18Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M331.868 75.1666C331.67 75.168 331.476 75.1203 331.301 75.0279C331.126 74.9354 330.977 74.8011 330.868 74.637L295.509 23.0706L259.638 61.3208L223.01 37.446L187.576 45.6677L151.588 74.8976C151.338 75.1004 151.018 75.1958 150.698 75.1627C150.378 75.1296 150.084 74.9707 149.881 74.721C149.678 74.4713 149.583 74.1512 149.616 73.8312C149.649 73.5111 149.808 73.2174 150.058 73.0145L186.483 43.4315L223.473 34.8483L259.268 58.1852L295.812 19.212L332.868 73.2667C332.994 73.4481 333.068 73.6604 333.081 73.8806C333.095 74.1009 333.048 74.3207 332.946 74.5163C332.844 74.7119 332.69 74.8759 332.502 74.9905C332.313 75.1051 332.097 75.166 331.876 75.1666H331.868Z",
    fill: "#253838"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M153.866 73.9554C153.866 74.549 153.69 75.1292 153.36 75.6228C153.03 76.1163 152.561 76.501 152.013 76.7281C151.465 76.9553 150.861 77.0147 150.279 76.8989C149.697 76.7831 149.162 76.4973 148.742 76.0775C148.323 75.6578 148.037 75.1231 147.921 74.5409C147.805 73.9587 147.865 73.3553 148.092 72.8069C148.319 72.2585 148.704 71.7898 149.197 71.46C149.691 71.1302 150.271 70.9542 150.864 70.9542C151.66 70.9542 152.424 71.2704 152.987 71.8332C153.549 72.3961 153.866 73.1594 153.866 73.9554Z",
    fill: "#94E0B3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M187.029 47.5507C188.686 47.5507 190.03 46.207 190.03 44.5495C190.03 42.892 188.686 41.5483 187.029 41.5483C185.371 41.5483 184.027 42.892 184.027 44.5495C184.027 46.207 185.371 47.5507 187.029 47.5507Z",
    fill: "#94E0B3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M223.236 39.1443C224.893 39.1443 226.237 37.8006 226.237 36.1431C226.237 34.4856 224.893 33.142 223.236 33.142C221.578 33.142 220.234 34.4856 220.234 36.1431C220.234 37.8006 221.578 39.1443 223.236 39.1443Z",
    fill: "#94E0B3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M259.446 62.7494C261.104 62.7494 262.448 61.4057 262.448 59.7482C262.448 58.0907 261.104 56.7471 259.446 56.7471C257.789 56.7471 256.445 58.0907 256.445 59.7482C256.445 61.4057 257.789 62.7494 259.446 62.7494Z",
    fill: "#94E0B3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M298.655 21.1453C298.655 21.7388 298.479 22.3191 298.149 22.8126C297.819 23.3062 297.35 23.6908 296.802 23.918C296.254 24.1452 295.65 24.2046 295.068 24.0888C294.486 23.973 293.951 23.6871 293.531 23.2674C293.112 22.8477 292.826 22.3129 292.71 21.7308C292.594 21.1486 292.654 20.5452 292.881 19.9968C293.108 19.4484 293.493 18.9797 293.986 18.6499C294.48 18.3201 295.06 18.1441 295.654 18.1441C296.449 18.1441 297.213 18.4603 297.776 19.0231C298.338 19.586 298.655 20.3493 298.655 21.1453Z",
    fill: "#94E0B3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M334.862 73.9554C334.862 74.549 334.686 75.1292 334.356 75.6228C334.026 76.1163 333.557 76.501 333.009 76.7281C332.461 76.9553 331.857 77.0147 331.275 76.8989C330.693 76.7831 330.158 76.4973 329.738 76.0775C329.319 75.6578 329.033 75.1231 328.917 74.5409C328.801 73.9587 328.861 73.3553 329.088 72.8069C329.315 72.2585 329.7 71.7898 330.193 71.46C330.687 71.1302 331.267 70.9542 331.861 70.9542C332.657 70.9542 333.42 71.2704 333.983 71.8332C334.546 72.3961 334.862 73.1594 334.862 73.9554Z",
    fill: "#94E0B3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M396.581 359.999C428.626 359.999 454.604 356.51 454.604 352.206C454.604 347.902 428.626 344.413 396.581 344.413C364.536 344.413 338.559 347.902 338.559 352.206C338.559 356.51 364.536 359.999 396.581 359.999Z",
    fill: "#94E0B3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M396.581 359.999C428.626 359.999 454.604 356.51 454.604 352.206C454.604 347.902 428.626 344.413 396.581 344.413C364.536 344.413 338.559 347.902 338.559 352.206C338.559 356.51 364.536 359.999 396.581 359.999Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6942 360C108.265 360 132.236 356.511 132.236 352.207C132.236 347.903 108.265 344.414 78.6942 344.414C49.1239 344.414 25.1523 347.903 25.1523 352.207C25.1523 356.511 49.1239 360 78.6942 360Z",
    fill: "#94E0B3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.6942 360C108.265 360 132.236 356.511 132.236 352.207C132.236 347.903 108.265 344.414 78.6942 344.414C49.1239 344.414 25.1523 347.903 25.1523 352.207C25.1523 356.511 49.1239 360 78.6942 360Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M380.205 77.6705C380.205 77.6705 402.248 75.5352 403.509 79.2089C404.77 82.8826 404.349 91.2724 404.349 91.2724C405.46 91.5611 406.543 91.9464 407.586 92.4241C407.88 92.7099 411.142 94.8452 408.098 98.3508C407.304 99.2397 406.341 99.9625 405.265 100.478C403.923 101.072 402.647 101.804 401.457 102.663L397.035 107.682L397.876 114.147C397.876 114.147 399.852 115.576 402.264 120.561C402.264 120.561 407.964 123.924 411.31 125.832C414.061 127.278 416.923 128.503 419.868 129.497C419.868 129.497 421.398 129.993 421.289 131.095C421.179 132.196 413.672 157.155 413.672 157.155L409.721 169.765C409.646 171.315 409.444 172.856 409.116 174.372C408.552 177.087 406.434 178.87 404.24 178.315L404.458 187.562C404.458 187.562 394.152 192.715 377.154 191.841C377.154 191.841 369.151 191.068 363.232 186.688L363.123 165.083L335.852 159.803C335.852 159.803 332.397 159.072 334.171 155.961C335.944 152.851 341.905 145.134 341.905 145.134L361.063 121.696C361.063 121.696 362.383 120.141 362.871 119.645C363.358 119.149 364.552 118.804 369.285 118.409C374.018 118.014 379.323 117.098 379.323 117.098C379.323 117.098 382.198 114.626 382.61 114.626C383.021 114.626 383.106 110.927 383.106 110.927C381.652 109.878 380.442 108.526 379.562 106.964C378.681 105.403 378.149 103.669 378.003 101.882C377.591 95.8792 380.222 81.8149 380.222 81.8149L380.205 77.6705Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M363.57 186.604C363.57 186.604 361.25 221.071 361.25 237.565C361.25 254.059 362.284 267.417 362.797 279.001C363.31 290.586 361.25 298.563 363.049 307.054C364.848 315.545 368.976 340.26 368.976 340.26L373.826 343.186C373.826 343.186 374.667 323.523 376.432 316.579C378.198 309.635 378.753 280.287 379.795 271.276C380.837 262.264 384.175 230.352 384.175 230.352C384.175 230.352 397.045 263.81 400.148 276.942C403.25 290.073 413.792 319.664 416.12 326.869C418.449 334.073 422.038 344.75 422.038 344.75C423.129 345.068 424.275 345.154 425.401 345.002C425.888 344.963 426.356 344.8 426.762 344.529C427.168 344.259 427.498 343.889 427.721 343.455C427.721 343.455 424.3 321.9 422.795 311.426C420.937 298.471 417.911 279.001 416.07 271.797C414.229 264.592 411.438 253.26 411.438 247.855C411.438 242.449 404.494 188.167 404.494 188.167C404.494 188.167 380.299 198.701 363.57 186.604Z",
    fill: "#253838"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M384.159 230.352L373.836 218.314",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M371.195 219.197L379.694 227.107",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M389.363 220.079C391.54 214.572 395.584 210.007 400.788 207.183",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M401.368 191.076C401.368 191.076 400.199 195.465 401.662 198.104C403.125 200.744 404.596 200.744 404.596 200.744C404.596 200.744 407.227 215.094 407.227 223.299C407.227 231.504 405.47 232.378 407.227 241.457C408.984 250.536 410.161 253.47 410.161 258.741C410.161 264.012 412.498 267.535 414.549 270.754C416.601 273.974 417.189 283.364 417.189 287.156C417.189 290.947 418.358 295.066 419.535 298.875C419.535 298.875 419.812 307.416 421.292 309.417C422.771 311.417 423.049 318.21 423.049 318.21",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M382.041 229.158C382.041 229.158 382.621 235.884 380.57 247.611C378.518 259.338 377.056 262.55 376.761 276.025C376.467 289.501 377.644 291.847 377.056 298.875C376.467 305.903 372.953 317.008 372.953 322.052C372.953 327.096 373.491 343.22 373.491 343.22",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M375.59 192.833L376.178 195.178L379.986 196.052L379.398 193.127",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M380.004 196.053C380.004 196.053 387.032 195.759 390.546 194.59L389.705 192.245",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M392.875 191.657L393.716 194.591C393.716 194.591 399.34 194.271 400.18 193.431",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 195.179C374.239 195.118 372.335 194.614 370.616 193.707L367.977 192.245L368.817 190.193",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M368.975 340.26C368.975 340.26 356.365 348.49 354.557 352.349C352.75 356.208 359.963 354.669 365.108 352.61C370.253 350.55 373.514 343.186 373.514 343.186L368.975 340.26Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M422.441 344.859C423.077 348.385 424.33 351.771 426.14 354.862C428.915 359.175 434.152 362.874 434.152 356.09C434.152 349.306 427.687 343.48 427.687 343.48C427.687 343.48 424.476 345.22 422.441 344.859Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M380.131 82.3278C380.131 82.3278 377.399 99.2755 378.324 103.479C380.434 112.886 387.84 112.482 392.472 110.683C396.802 109.002 401.123 103.059 401.678 102.277C401.717 102.222 401.773 102.18 401.837 102.159C402.527 101.966 406.806 100.604 408.689 97.3C410.748 93.6935 406.89 92.1551 406.89 92.1551",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M397.659 106.64L401.745 102.151C401.745 102.151 406.579 100.663 408.689 97.2583C409.924 95.266 409.243 93.5258 408.495 93.055C407.47 92.5 406.412 92.0087 405.326 91.5839L403.956 94.6018L402.787 94.8036C402.787 94.8036 403.275 91.6931 401.862 89.8521C400.45 88.011 400.131 82.6812 400.131 82.6812C400.131 82.6812 398.155 93.3072 397.911 97.7543C397.849 100.229 397.075 102.634 395.684 104.681C395.684 104.681 395.936 107.397 396.423 110.112C396.482 110.432 396.541 110.911 396.6 111.508L397.272 110.432L397.642 111.457C397.222 109.692 397.029 107.817 397.659 106.64Z",
    fill: "#94E0B3"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M380.131 82.3278C380.131 82.3278 377.399 99.2755 378.324 103.479C380.434 112.886 387.84 112.482 392.472 110.683C396.802 109.002 401.123 103.059 401.678 102.277C401.717 102.222 401.773 102.18 401.837 102.159C402.527 101.966 406.806 100.604 408.689 97.3C410.748 93.6935 406.89 92.1551 406.89 92.1551",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M390.59 90.9443C390.43 91.6168 390.59 92.2221 390.901 92.2978C391.212 92.3734 391.633 91.9027 391.792 91.2385C391.952 90.5744 391.792 89.9691 391.481 89.8851C391.17 89.801 390.75 90.2802 390.59 90.9443Z",
    fill: "#253838"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M383.368 89.1884C383.208 89.861 383.368 90.4662 383.679 90.5419C383.99 90.6176 384.41 90.1468 384.57 89.4827C384.729 88.8185 384.57 88.2049 384.259 88.1292C383.948 88.0535 383.519 88.5159 383.368 89.1884Z",
    fill: "#253838"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M395.069 88.0028C394.672 87.3038 394.106 86.7153 393.424 86.2909C392.741 85.8666 391.963 85.6198 391.16 85.5732",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M385.628 85.6988C384.966 85.4096 384.232 85.3287 383.524 85.4668C382.815 85.605 382.165 85.9557 381.66 86.4722",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M386.116 88.7593C386.132 89.8854 386.048 91.0107 385.864 92.1219C385.587 93.5258 384.494 93.8033 384.771 94.8877C385.049 95.9722 386.453 96.0815 386.453 96.0815",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M387.914 100.46C388.509 100.65 389.138 100.708 389.758 100.631C390.377 100.554 390.973 100.344 391.504 100.015",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M401.233 70.4914C401.233 70.4914 395.576 65.5988 390.17 65.5988C384.765 65.5988 380.385 68.6924 377.039 68.9614C373.693 69.2304 371.381 66.1284 369.322 70.2476C367.262 74.3669 374.988 81.3192 380.133 82.3448C385.277 83.3704 392.482 81.832 394.542 81.5714C396.515 81.4361 398.495 81.4361 400.468 81.5714C400.468 81.5714 398.921 86.464 400.468 88.0109C402.015 89.5577 402.267 90.5833 402.267 91.6089C402.356 92.7408 402.527 93.8648 402.78 94.9716L404.327 95.4928L405.1 92.6597C407.187 90.4343 408.614 87.6719 409.22 84.6818C409.985 80.0498 406.126 75.4345 406.126 75.4345L401.233 70.4914Z",
    fill: "#253838"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M379.559 80.235C379.559 80.235 388.36 81.9163 395.254 79.0497C402.147 76.183 396.204 70.4917 396.204 70.4917",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M397.66 70.0117C398.375 70.0117 404.318 74.5261 403.124 77.8551C401.931 81.1841 399.56 81.4279 399.56 81.4279",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M396.684 172.128L389.252 168.211C387.342 168.105 385.443 167.858 383.569 167.471C381.838 166.975 364.066 165.277 364.066 165.277L363.797 169.48C363.797 169.48 384.065 172.204 388.26 172.7C392.455 173.196 396.171 175.171 396.911 176.407C397.65 177.643 399.138 178.879 398.399 182.292C397.659 185.705 392.716 190.698 392.716 190.698C392.48 190.345 404.603 189.471 404.485 188.176C404.224 185.604 402.854 178.089 402.854 178.089L396.684 172.128Z",
    fill: "#94E0B3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M396.684 172.128L389.252 168.211C387.342 168.105 385.443 167.858 383.569 167.471C381.838 166.975 364.066 165.277 364.066 165.277L363.797 169.48C363.797 169.48 384.065 172.204 388.26 172.7C392.455 173.196 396.171 175.171 396.911 176.407C397.65 177.643 399.138 178.879 398.399 182.292C397.659 185.705 392.716 190.698 392.716 190.698C392.522 190.32 404.628 189.463 404.485 188.176C404.09 184.898 402.854 178.089 402.854 178.089L396.684 172.128Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M421.199 131.002C420.543 127.926 415.65 128.338 412.7 126.631C409.749 124.924 402.612 120.973 402.612 120.973L399.157 115.778C398.533 114.377 398.03 112.926 397.652 111.44L397.282 110.415L396.609 111.491C397.038 116.097 397.45 127.892 397.45 127.892L398.93 135.307C398.93 135.307 404.621 159.77 406.1 165.209C407.58 170.648 407.58 174.347 406.596 176.079C405.613 177.811 405.941 178.601 405.941 178.601C405.941 178.601 409.799 175.617 409.564 172.657C409.253 169.177 421.661 133.087 421.199 131.002Z",
    fill: "#94E0B3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M421.199 131.002C420.863 127.875 415.65 128.338 412.7 126.631C409.749 124.924 402.612 120.973 402.612 120.973L399.157 115.778C398.533 114.377 398.03 112.926 397.652 111.44L397.282 110.415L396.609 111.491C397.038 116.097 397.45 127.892 397.45 127.892L398.93 135.307C398.93 135.307 404.621 159.77 406.1 165.209C407.58 170.648 407.58 174.347 406.596 176.079C405.613 177.811 405.941 178.601 405.941 178.601C405.941 178.601 409.909 175.608 409.564 172.657C409.169 169.488 421.501 133.6 421.199 131.002Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M399.602 127.917C399.602 127.917 398.055 114.021 397.282 110.415C396.508 106.808 397.029 104.757 393.684 104.757C390.338 104.757 386.218 104.236 386.958 106.043C387.698 107.851 392.843 106.295 393.684 107.069C394.524 107.842 393.936 109.641 393.936 109.641C393.936 109.641 387.21 110.162 387.21 111.961C387.21 113.76 387.471 118.687 388.757 119.166C390.043 119.645 390.556 116.854 390.556 116.854C390.556 116.854 390.817 122.739 392.103 124.832C392.922 126.125 393.872 127.33 394.936 128.43L399.602 127.917Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M394.969 131.776C394.969 131.776 394.195 163.722 395.482 168.841C396.768 173.961 403.72 180.938 407.318 177.592C410.916 174.247 409.126 167.042 409.126 163.696C409.126 160.35 400.887 135.643 400.887 133.836C400.765 132.335 400.416 130.861 399.853 129.464",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M395.48 135.642L400.625 135.121",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M362.577 151.616L363.569 123.193C363.569 123.193 362.334 122.453 361.838 125.168C361.342 127.884 361.098 133.331 361.098 133.331C361.098 133.331 355.163 129.624 356.651 131.843C358.139 134.063 360.602 139.014 360.602 139.014L351.422 148.152L355.625 149.884L362.577 151.616Z",
    fill: "#94E0B3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.577 151.616L363.569 123.193C363.569 123.193 362.334 122.453 361.838 125.168C361.342 127.884 361.098 133.331 361.098 133.331C361.098 133.331 355.163 129.624 356.651 131.843C358.139 134.063 360.602 139.014 360.602 139.014L351.422 148.152L355.625 149.884L362.577 151.616Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M374.885 129.54C374.885 129.54 374.414 131.221 376.39 131.221C378.365 131.221 381.837 129.817 381.837 129.817L381.585 127.026C381.585 127.026 376.835 129.338 374.885 129.54Z",
    fill: "#94E0B3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M374.885 129.54C374.885 129.54 374.414 131.221 376.39 131.221C378.365 131.221 381.837 129.817 381.837 129.817L381.585 127.026C381.585 127.026 376.835 129.338 374.885 129.54Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M383.368 110.742C383.368 110.742 380.796 125.874 382.343 129.237C383.889 132.599 386.201 131.809 388 130.271C389.799 128.732 392.12 124.865 392.12 124.865",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M363.051 165.495L363.572 186.604C363.572 186.604 369.457 192.261 380.814 192.261C392.171 192.261 404.496 188.142 404.496 188.142V180.677",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M397.801 113.761C397.801 113.761 402.433 118.393 402.433 122.773C402.433 127.152 401.659 128.178 401.659 128.178",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 120.2C401.914 120.2 408.866 124.311 412.725 126.632C416.584 128.952 421.224 128.943 421.224 131.003C421.224 133.063 410.413 168.068 410.413 168.068",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M406.291 131.776L403.719 142.074",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M363.114 137.82L358.953 129.094",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M363.117 140.317L356.879 136.576",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M383.471 159.837L382.227 166.075",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M417.121 130.759C417.121 130.759 410.892 132.004 405.074 139.065",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M412.97 130.38C412.97 130.38 411.288 129.96 405.496 134.945",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M383.469 132.423L380.98 151.944L383.057 152.364L384.721 146.135",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M385.134 183.518C377.652 189.756 367.27 189.336 367.27 189.336",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 149.615C353.517 149.615 348.431 144.957 341.227 150.884",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M382.87 114.534C382.87 114.534 380.81 115.046 378.49 118.653C376.17 122.259 373.345 128.43 375.405 128.943C377.465 129.455 381.29 127.144 381.29 127.144",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M390.852 128.178L393.424 130.49",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M379.265 117.107C379.265 117.107 369.741 118.393 365.882 118.653C362.023 118.914 362.772 120.335 361.511 121.226C359.476 122.647 336.139 152.23 334.609 155.063C333.079 157.896 333.323 159.182 335.896 159.955C338.468 160.729 364.092 165.235 364.092 165.235L386.731 167.555L388.53 161.889C388.53 161.889 393.792 162.586 394.717 162.586",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M385.956 159.804C380.959 158.354 376.13 156.382 371.547 153.919",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M369.49 153.398C369.49 153.398 361.924 150.59 357.83 150.077C353.736 149.564 347.465 149.396 347.465 149.396",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M362.535 150.052L363.309 129.717",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M386.73 167.554C388.497 168.442 390.347 169.152 392.254 169.672",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9033 151.17L52.9381 134.583L72.1473 127.018C72.1473 127.018 73.0804 121.864 74.022 121.637C74.9635 121.41 75.8882 119.292 75.8882 119.292L75.4259 115.046C75.4259 115.046 77.1829 108.321 86.0182 113.558C86.0182 113.558 83.3449 115.341 83.8073 116.08C84.2697 116.82 83.2945 119.174 84.463 119.174C85.6315 119.174 87.9938 120.662 89.1875 121.864C90.023 122.762 90.7613 123.745 91.3901 124.798L101.335 125.37C102.355 125.378 103.369 125.517 104.353 125.782C104.521 120.923 103.924 117.215 102.747 114.332C98.4685 103.924 90.6671 100.209 89.549 94.9966C88.4309 89.7845 88.9942 89.2381 88.9942 89.2381C90.1311 88.0821 90.9634 86.6623 91.4168 85.1056C91.8701 83.549 91.9303 81.9042 91.5918 80.3186C90.4822 74.745 86.2032 70.8359 70.777 70.0961C55.3508 69.3563 57.587 79.9403 57.587 79.9403L57.7719 80.6801C57.7719 80.6801 47.9193 84.0428 49.7856 96.4762C51.6519 108.91 57.0321 114.315 56.8472 118.216C56.6622 122.116 50.8953 123.604 42.7156 132.507C34.536 141.41 32.8715 154.801 36.2173 163.536C37.8986 167.832 41.1856 171.413 45.3133 174.086L49.9033 151.17Z",
    fill: "#253838"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7806 152.81V156.559L55.6602 178.559C60.1095 179.736 64.7757 179.834 69.2705 178.845C71.8078 178.184 74.2329 177.15 76.4666 175.777L62.7806 152.81Z",
    fill: "#253838"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2511 115.946L84.0918 119.729C84.0918 119.729 86.6138 117.207 91.5401 124.865C91.5401 124.865 101.779 124.622 104.57 126.017C104.57 126.017 105.15 126.185 107.042 128.194C108.933 130.204 116.045 136.601 116.045 136.601C116.045 136.601 125.175 145.075 126.083 145.731C126.991 146.386 130.396 149.64 132.943 150.775L139.769 135.231L142.812 127.539L144.494 121.209H145.032L145.149 116.106L144.737 110.019C144.804 109.71 144.946 109.421 145.149 109.179C145.854 108.202 146.396 107.117 146.755 105.967C146.755 105.396 146.175 102.016 146.175 102.016C146.175 102.016 145.889 101.175 146.511 101.075C147.133 100.974 149.428 101.772 149.714 103.378L150.555 103.092C151.251 101.429 152.119 99.8426 153.144 98.3593C154.506 96.5939 155.901 95.4842 156.767 96.0558C157.005 96.2197 157.176 96.4631 157.25 96.7421C157.324 97.0211 157.296 97.3174 157.171 97.5774L154.464 102.554C154.464 102.554 153.27 104.16 154.75 104.732C154.75 104.732 157.953 106.791 158.163 108.599C158.373 110.406 157.213 111.961 156.187 113.289C155.162 114.618 153.354 117.493 153.354 117.493L151.252 119.351L150.412 122.554L151.404 123.789L149.924 130.204L148.857 135.012L148.319 137.929L144.956 149.446L141.593 159.484C141.593 159.484 139.861 165.234 135.667 165.074C131.472 164.915 126.873 162.645 125.385 161.905C123.897 161.165 111.632 154.759 111.632 154.759L109.11 153.566C109.447 154.714 109.591 155.91 109.539 157.105C109.497 159.324 107.109 164.217 106.411 165.327L106 174.002C105.837 175.507 105.865 177.027 106.084 178.525C106.453 180.786 108.345 193.581 108.757 195.179C108.757 195.179 104.671 198.877 92.4984 200.634C80.3256 202.391 74.6259 199.542 74.6259 199.542L69.2036 196.355L75.8869 183.149C75.8869 183.149 77.5682 179.223 77.4001 178.189C77.232 177.155 74.3569 172.699 74.3569 172.699L63.8066 153.919L63.3106 154.087L61.6713 159.568L55.7446 178.155L47.9432 201.357C47.9432 201.357 45.808 207.242 44.9253 208.982L42.4621 216.489C42.5989 217.83 42.9303 219.144 43.4457 220.39L37.25 216.38L38.3513 210.495L39.7216 201.719L41.4029 192.177L42.8825 184.284L45.2447 173.758L46.0854 170.85L47.7667 162.628L50.7258 147.715L53.2478 134.945L70.9018 127.925L72.003 127.085C72.2479 125.46 72.8447 123.907 73.7516 122.537C74.3811 121.635 75.1306 120.823 75.9794 120.124C75.9794 120.124 75.8953 119.023 75.8365 117.98C75.7776 116.938 75.5086 115.021 75.5086 115.021C75.5086 115.021 80.9645 117.367 83.2511 115.946Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6055 82.159C59.6055 82.159 62.8757 74.9208 69.416 74.9208C75.9564 74.9208 89.4995 87.7662 89.4995 87.7662",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4023 83.3026C62.4023 83.3026 66.3703 79.0993 71.2798 80.7302C76.1892 82.3611 76.887 88.2037 76.887 88.2037",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1324 84.0258C59.1324 84.0258 53.2982 87.2959 52.8275 93.3739C52.3567 99.4519 60.9987 106.682 62.1672 114.861C63.3358 123.041 57.2662 124.899 47.4556 131.675C37.6451 138.45 39.2844 153.624 41.386 156.895",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5547 158.769C42.5547 158.769 43.9502 161.804 46.0519 162.737",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8405 99.9064C59.5642 100.5 59.4402 101.152 59.4799 101.806C59.5195 102.459 59.7215 103.092 60.0674 103.647C61.236 105.749 70.1554 116.257 69.4156 121.167C68.6758 126.076 64.0438 129.103 64.0438 129.103",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M64.269 84.0258C64.269 84.0258 58.8971 86.3628 59.1325 91.7346C59.3679 97.1065 60.5364 98.5104 60.5364 98.5104",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 101.797C91.1691 105.575 93.4594 109.048 96.2758 112.07C100.479 116.273 100.941 122.351 100.941 122.351",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3984 115.088C94.3984 115.088 96.5001 119.998 96.5001 123.033",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7734 116.392L76.1742 122.335C76.1742 122.335 75.468 124.134 74.1398 127.018C72.8115 129.901 73.0301 135.424 73.0301 135.424L77.0989 143.52C77.0989 143.52 69.2723 134.542 68.8268 133.432C68.3812 132.322 60.1931 134.323 58.6463 134.987C57.0995 135.651 55.0987 136.979 55.5443 138.972C55.9898 140.964 57.9822 143.612 57.0911 144.058C56.2 144.503 53.7705 143.394 53.7705 144.722C53.7705 146.05 56.654 151.145 55.3257 152.91C53.9975 154.675 45.5824 183.241 45.5824 183.241C45.5824 183.241 50.8954 178.811 49.5672 180.585C48.2389 182.359 41.8246 196.742 41.8246 196.742L39.3867 205.149L45.1453 175.272L50.0127 150.052L52.9382 134.584C55.7629 133.642 72.1474 127.018 72.1474 127.018C72.1474 127.018 73.442 121.57 75.8884 119.292L75.426 115.047C75.426 115.047 79.8899 116.61 82.7734 116.392Z",
    fill: "#94E0B3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.7734 116.392L76.1742 122.335C76.1742 122.335 75.468 124.134 74.1398 127.018C72.8115 129.901 73.0301 135.424 73.0301 135.424L77.0989 143.52C77.0989 143.52 69.2723 134.542 68.8268 133.432C68.3812 132.322 60.1931 134.323 58.6463 134.987C57.0995 135.651 55.0987 136.979 55.5443 138.972C55.9898 140.964 57.9822 143.612 57.0911 144.058C56.2 144.503 53.7705 143.394 53.7705 144.722C53.7705 146.05 56.654 151.145 55.3257 152.91C53.9975 154.675 45.5824 183.241 45.5824 183.241C45.5824 183.241 50.8954 178.811 49.5672 180.585C48.2389 182.359 41.8246 196.742 41.8246 196.742L39.3867 205.149L45.1453 175.272L50.0127 150.052L52.9382 134.584C55.7629 133.642 72.1474 127.018 72.1474 127.018C72.1474 127.018 72.5005 121.974 75.8968 120.208L75.426 115.047C75.426 115.047 79.8899 116.61 82.7734 116.392Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M107.336 146.269C107.336 146.269 111.321 139.636 111.766 141.183C112.212 142.73 110.657 148.035 110.657 148.035C110.657 148.035 114.86 146.488 114.423 147.816C113.986 149.144 113.094 149.808 113.313 150.473C113.532 151.137 127.924 158.661 129.698 159.543C131.471 160.426 135.675 155.34 137.667 156.887C139.659 158.434 137.667 163.738 133.682 163.747C129.698 163.755 118.189 158.703 118.189 158.703L109.127 153.432",
    fill: "#94E0B3"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.336 146.269C107.336 146.269 111.321 139.636 111.766 141.183C112.212 142.73 110.657 148.035 110.657 148.035C110.657 148.035 114.86 146.488 114.423 147.816C113.986 149.144 113.094 149.808 113.313 150.473C113.532 151.137 127.924 158.661 129.698 159.543C131.471 160.426 135.675 155.34 137.667 156.887C139.659 158.434 137.667 163.738 133.682 163.747C129.698 163.755 118.189 158.703 118.189 158.703L109.16 153.448",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4375 173.052C83.4375 173.052 109.313 159.332 105.11 164.418C100.906 169.504 86.9767 175.271 83.4375 173.052Z",
    fill: "#94E0B3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M83.4375 173.052C83.4375 173.052 109.313 159.332 105.11 164.418C100.906 169.504 86.9767 175.271 83.4375 173.052Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4258 115.088C75.4258 115.088 75.6107 118.619 76.174 122.335C76.7372 126.051 76.5439 126.051 80.0747 130.506C83.6054 134.962 87.3212 138.686 87.876 137.946",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M88.061 136.643C88.061 136.643 88.4309 130.137 87.1363 125.866C85.8416 121.595 83.9754 120.099 83.9754 119.141C83.9125 118.142 83.789 117.148 83.6055 116.165",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4255 120.476C73.9406 121.813 72.9018 123.574 72.4495 125.52C71.8947 128.488 71.3398 132.019 71.3398 132.019L77.0984 143.544C77.5998 141.537 78.3481 139.6 79.3262 137.777C79.8106 136.877 80.438 136.063 81.184 135.364",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3637 133.481C89.7703 133.379 90.193 133.36 90.6073 133.423C91.0216 133.487 91.419 133.632 91.7764 133.851C93.2644 134.599 96.2403 138.5 96.2403 138.5C96.2403 138.5 94.1975 128.832 90.6667 123.822C87.136 118.812 84.7148 119.173 84.7148 119.173",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7762 127.724L52.9373 134.583C52.9373 134.583 46.439 170.076 44.0179 179.55C41.5968 189.025 37.5195 215.791 37.5195 215.791L42.3449 216.716L44.0263 211.891",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9531 209.117C44.9531 209.117 46.0628 207.435 49.0388 198.188C52.0147 188.941 59.9674 166.243 61.304 161.762C62.6407 157.281 63.7167 154.33 63.7167 154.33",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5547 148.875C60.5547 148.875 75.6026 175.776 76.9056 176.936C78.2086 178.096 76.3508 181.207 75.9725 182.88",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3059 186.259L69.4805 196.296C69.4805 196.296 72.6414 201.13 86.0163 201.13C93.9759 201.155 101.822 199.239 108.874 195.548C108.874 195.548 105.713 178.827 105.898 175.852C106.083 172.876 106.461 165.074 106.461 165.074C106.461 165.074 109.824 160.03 109.429 156.155C109.034 152.279 107.386 147.79 107.386 147.05C107.386 146.311 107.016 138.316 107.016 138.316",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9922 169.74L99.3083 161.568",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0039 167.175L100.242 162.972",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M132.852 150.951L130.137 157.601",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M131.767 153.86L129.203 156.432",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8641 177.457C55.8641 177.457 51.4254 182.594 48.3906 184.696",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2978 178.853C53.2978 178.853 45.5889 184.922 43.7227 186.326",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M54.668 135.642C56.9918 138.928 59.098 142.363 60.9729 145.924",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M61.707 147.555L63.3379 150.354",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M107.387 147.051L109.43 136.643",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M108.137 147.79L111.289 143.334",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7163 154.296L54.7969 149.463",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6914 138.871C87.6914 138.871 91.0541 145.597 92.1553 150.397",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M142.879 127.16C143.768 127.094 144.662 127.21 145.506 127.499C146.349 127.788 147.126 128.244 147.788 128.841",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 211.177L43.0534 212.034",
    stroke: "#253838",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4598 216.127C37.4887 219.324 37.3203 222.519 36.9554 225.694C36.4006 229.603 36.5855 238.523 37.3253 241.305C38.0651 244.088 38.4434 244.668 39.1832 242.987C39.923 241.305 42.1591 231.469 42.1591 231.469C42.1591 231.469 42.529 237.968 44.2019 237.413C45.8749 236.858 44.9501 233.697 44.9501 230.906C44.9501 228.115 45.1351 227.191 44.9501 224.963C44.7652 222.735 42.2852 217.229 42.2852 217.229",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4598 216.127C37.4887 219.324 37.3203 222.519 36.9554 225.694C36.4006 229.603 36.5855 238.523 37.3253 241.305C38.0651 244.088 38.4434 244.668 39.1832 242.987C39.923 241.305 42.1591 231.469 42.1591 231.469C42.1591 231.469 42.529 237.968 44.2019 237.413C45.8749 236.858 44.9501 233.697 44.9501 230.906C44.9501 228.115 45.1351 227.191 44.9501 224.963C44.7652 222.735 42.2852 217.229 42.2852 217.229",
    stroke: "#253838",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 121.065C144.966 119.421 144.966 117.774 145.05 116.131C145.201 114.584 144.588 112.272 144.739 110.246C144.89 108.22 146.9 107.472 146.589 104.849C146.277 102.226 145.664 101.915 146.126 101.301C146.589 100.688 149.489 101.604 149.674 103.302C149.839 105.05 149.839 106.809 149.674 108.556C149.522 109.019 150.598 111.919 149.985 113.18C149.633 113.863 149.373 114.589 149.211 115.34",
    stroke: "#253838",
    strokeWidth: 0.880843,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M150.297 103.167C150.297 103.167 153.844 96.0722 155.854 95.9125C157.863 95.7527 157.241 97.5938 156.619 98.5353C155.997 99.4769 153.996 102.856 153.844 104.252C153.693 105.647 151.835 110.263 151.835 110.263",
    stroke: "#253838",
    strokeWidth: 0.880843,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M153.869 104.252C153.869 104.252 159.274 107.489 158.072 110.137C156.87 112.785 156.214 113.844 155.289 113.5C154.47 113.081 153.736 112.51 153.129 111.818",
    stroke: "#253838",
    strokeWidth: 0.880843,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M155.851 113.508C155.851 113.508 154.456 115.82 153.38 117.215C152.761 118.021 152.028 118.732 151.203 119.325L150.547 121.604",
    stroke: "#253838",
    strokeWidth: 0.880843,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0352 124.747C91.0352 124.747 103.855 124.562 105.528 126.605C107.201 128.648 127.461 147.235 129.907 148.908C132.354 150.581 132.883 150.951 132.883 150.951C132.883 150.951 142.913 128.253 142.913 127.16C142.913 126.067 144.594 121.032 144.594 121.032C144.594 121.032 147.755 121.401 148.503 121.401C149.251 121.401 151.286 123.823 151.286 123.823C151.286 123.823 148.503 135.155 148.503 136.433C148.503 137.71 143.299 155.389 140.878 160.812C138.457 166.234 135.12 165.452 129.731 163.779C124.342 162.106 109.664 153.75 109.664 153.75",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4825 196.296C69.4825 196.296 62.0427 214.909 60.0335 227.577C58.0243 240.246 58.8818 269.871 58.3017 273.041C57.7216 276.21 49.6681 291.165 49.6681 298.361C49.6681 305.557 45.3555 342.673 45.3555 342.673L48.2305 344.396C48.2305 344.396 58.3185 313.292 62.0427 305.263C65.7668 297.235 70.9621 278.219 72.3996 274.478C73.8372 270.737 83.9167 240.81 84.4884 237.069C85.06 233.328 88.5152 224.122 88.5152 224.122C88.5152 224.122 95.9971 269.871 97.4346 279.371C98.8721 288.87 108.943 340.369 108.943 340.369C109.605 340.531 110.281 340.627 110.961 340.655C111.802 340.655 112.113 339.218 112.113 339.218C112.113 339.218 116.139 302.674 114.988 292.889C113.836 283.103 110.389 271.031 110.389 267.568C110.389 264.104 115.568 234.194 115.568 223.853C115.568 213.513 108.842 195.565 108.842 195.565C108.842 195.565 84.976 207.603 69.4825 196.296Z",
    fill: "#253838"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M110.281 269.469C110.281 269.469 107.717 280.448 104.211 286.282",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M109.582 280.682C109.582 280.682 107.481 288.618 103.277 292.359",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8398 277.177C59.8398 277.177 61.4707 286.752 63.337 290.72",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3711 282.784C59.3711 282.784 60.775 289.56 63.339 293.527",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2617 224.165L98.6015 216.456",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7031 220.895L104.682 215.985",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6406 207.813C69.6406 207.813 76.8871 212.479 81.0905 216.455",
    stroke: "white",
    strokeWidth: 0.530341,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6591 342.647C45.6591 342.647 34.7305 351.894 34.7305 356.484C34.7305 361.074 39.0431 360.797 43.6499 356.484C48.2568 352.171 48.4921 343.286 48.4921 343.286L45.6591 342.647Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M108.941 340.37C108.941 340.37 112.682 349.575 116.718 353.61C120.753 357.645 123.048 359.074 123.048 354.753C123.048 350.432 120.459 345.548 112.119 339.218C112.111 339.218 114.414 340.941 108.941 340.37Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3386 85.5722C69.5904 85.2948 68.8842 84.9586 68.1528 84.6475C67.4215 84.3365 66.0848 84.1683 65.5804 86.4633C64.8322 89.826 70.0359 92.6002 68.363 95.3828C67.3223 97.0756 65.7581 98.383 63.9075 99.1069C63.6062 99.2105 63.2923 99.2727 62.9744 99.2919C61.4864 99.4768 59.0737 99.2919 59.8135 101.89C60.5532 104.487 62.9744 106.723 64.4623 106.723H65.9503C65.9503 106.723 67.6316 111.767 73.9366 114.525C80.2416 117.282 84.529 117.131 86.017 113.6C87.5049 110.069 88.623 107.093 88.623 102.444C88.623 97.7955 86.9417 89.9941 86.9417 89.9941C86.9417 89.9941 85.4537 92.0454 79.6952 89.4393C75.887 87.7159 72.3225 86.3204 70.3386 85.5722Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7043 89.4397C79.7043 89.4397 70.8185 88.9437 69.4903 89.1622C68.162 89.3808 69.7088 93.3656 69.2717 97.3503C68.8345 101.335 69.0447 107.758 70.8185 109.75C72.9117 111.804 75.1296 113.728 77.4597 115.509C77.4597 115.509 70.642 114.407 68.162 111.524C65.682 108.64 65.2869 107.094 65.2869 107.094C65.2869 107.094 59.5284 103.731 59.0828 101.116C58.6373 98.502 62.4455 99.8891 64.2697 98.5945C65.2953 97.8883 69.5407 96.5601 68.473 93.0209C67.4054 89.4817 65.682 88.8176 65.6148 86.4469C65.5644 84.7656 67.0439 84.278 67.9518 84.1267C68.3611 84.0578 68.7818 84.1195 69.154 84.3032L79.7043 89.4397Z",
    fill: "#94E0B3"
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3386 85.5722C69.5904 85.2948 68.8842 84.9586 68.1528 84.6475C67.4215 84.3365 66.0848 84.1683 65.5804 86.4633C64.8322 89.826 70.0359 92.6002 68.363 95.3828C67.3223 97.0756 65.7581 98.383 63.9075 99.1069C63.6062 99.2105 63.2923 99.2727 62.9744 99.2919C61.4864 99.4768 59.0737 99.2919 59.8135 101.89C60.5532 104.487 62.9744 106.723 64.4623 106.723H65.9503C65.9503 106.723 67.6316 111.767 73.9366 114.525C80.2416 117.282 84.529 117.131 86.017 113.6C87.5049 110.069 88.623 107.093 88.623 102.444C88.623 97.7955 86.9417 89.9941 86.9417 89.9941C86.9417 89.9941 85.4537 92.0454 79.6952 89.4393C75.887 87.7159 72.3225 86.3204 70.3386 85.5722Z",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M76.906 96.5844C77.0237 97.2906 76.8303 97.9127 76.4688 97.9715C76.1073 98.0303 75.7374 97.5007 75.6282 96.7946C75.5189 96.0884 75.7122 95.4579 76.0653 95.3991C76.4184 95.3402 76.7883 95.9119 76.906 96.5844Z",
    fill: "#253838"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5982 95.2991C84.7075 96.0052 84.5141 96.6273 84.161 96.6862C83.808 96.745 83.4297 96.2154 83.3204 95.5092C83.2111 94.8031 83.396 94.181 83.7491 94.1221C84.1022 94.0633 84.4805 94.5929 84.5982 95.2991Z",
    fill: "#253838"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4492 93.1556C72.9196 92.4564 73.5576 91.8862 74.3051 91.497C75.0526 91.1079 75.8856 90.9122 76.7282 90.9279",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4883 91.4821C83.2024 91.2325 83.9754 91.2058 84.7051 91.4055C85.4347 91.6051 86.0864 92.0218 86.5739 92.6002",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7495 94.6432C81.6468 95.8179 81.6468 96.9993 81.7495 98.174C81.9345 99.662 83.0442 100.032 82.6743 101.15C82.3044 102.268 80.8164 102.26 80.8164 102.26",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9579 106.724C78.3212 106.875 77.6596 106.886 77.0182 106.757C76.3769 106.627 75.7711 106.361 75.2422 105.976",
    stroke: "#253838",
    strokeWidth: 1.06068,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExplanation1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explanation-1.db120aad.svg";
export { ForwardRef as ReactComponent };